import React from 'react';
import classNames from 'classnames';
import './Progress.scss';

const steps = [
  'Select room and item',
  'What type of issue are you experiencing?',
  'Diagnose',
];

interface ProgressProps {
  currentStep: number;
  totalSteps: number;
}

const Progress = ({ currentStep, totalSteps }: ProgressProps) => (
  <ul className="sr-form-progress">
    {steps.map((step, x) => (
      <li
        key={x}
        className={classNames('sr-form-progress__step', {
          'sr-form-progress__step--active': currentStep === x,
          'sr-form-progress__step--complete': currentStep > x,
        })}
      >
        <div className="sr-form-progress__label">{step}</div>
      </li>
    ))}
  </ul>
);

export default Progress;
